module.exports = __webpack_public_path__ + "static/media/Stacy P.1b429d86.png";